import { QAV } from 'qunar-react-native';

class PerfQav {
    public businessType: any;
    public pageId: any;
    public pageType: any;
    public eventMap: any;
    public isCold: boolean;

    public constructor({
        businessType,
        pageId,
        pageType
    }: {
        businessType: any;
        pageId: any;
        pageType: any;
    }) {
        this.businessType = businessType;
        this.pageId = pageId;
        this.pageType = pageType;
        this.eventMap = {};
    }

    public setClickTime(clickTime: any) {
        this.eventMap.clickTime = clickTime;
    }

    public setBizStart(bizStart: any) {
        this.eventMap.bizStart = bizStart;
    }

    public setOnshow(onshow: any) {
        this.eventMap.onshow = onshow;
    }

    public setDidLoad(didLoad: any) {
        this.eventMap.didLoad = didLoad;
    }

    public setReqStart(reqStart: any) {
        this.eventMap.reqStart = reqStart;
    }

    public setReqEnd(reqEnd: any) {
        this.eventMap.reqEnd = reqEnd;
    }

    public setWillUpdate(willUpdate: any) {
        this.eventMap.willUpdate = willUpdate;
    }

    public setDidUpdate(didUpdate: any) {
        this.eventMap.didUpdate = didUpdate;
    }

    public setIsCold(isCold: any) {
        this.isCold = isCold;
    }

    public send() {
        const message = JSON.stringify({
            businessType: this.businessType,
            pageId: this.pageId,
            pageType: this.pageType,
            eventTs: Date.now(),
            eventMap: this.eventMap,
            isCold: this.isCold
        });
        let fieldMissing = false;
        Object.keys(this.eventMap).forEach((key) => {
            if (!this.eventMap[key] || this.eventMap[key] === 0) {
                fieldMissing = true;
            }
        });

        if (fieldMissing) {
            return;
        }

        const logStr = `pubMonitor${message}`;

        if (QAV.logMsg) {
            QAV.logMsg(logStr);
        } else {
            QAV.log && QAV.log('cmn_order_rn', logStr);
        }
        // console.log('性能埋点--' + logStr)
    }
}

export default PerfQav;
